export interface CsTabButtonInterface {
  deselect(): void;
  select(): void;
  getValue(): any;
}

export class CsTabButtonBase implements CsTabButtonInterface {
  select(): void {
    throw new Error("Method not implemented.");
  }
  getValue(): any {
    throw new Error("Method not implemented.");
  }
  deselect(): void {
    throw new Error("Method not implemented.");
  }

}